/**
 * @desc 编辑账单补充信息
 */
const URL = "/rantion-rms";
import http, { updateResponse } from "@/http";
export type Response = defs.rms.Response;
export function request(body: defs.rms.BillInfoImportRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/expenseReimbursement/editBillInfo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
